const appConfig = {
  backendApiUrl: process.env.REACT_APP_SERVER_URL || "",
};

export const getBackendApiUrl = () => appConfig.backendApiUrl.replace(/\/$/, "");

export default appConfig;
